// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/stylus/components/_buttons.styl
// module id = 112
// module chunks = 0